import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { testimonials } from '../data/content';
export function TestimonialsSection() {
  return <section aria-labelledby="testimonios" className="bg-white" data-id="element-201" data-mp="1mzivf8h58roa">
      <div className="mx-auto max-w-page px-3 py-5 sm:px-6 sm:py-7" data-id="element-202" data-mp="1r140w8rcm3og">
        <Reveal className="text-center" data-id="element-203" data-mp="1qz9k96n40xq6">
          <p className="text-[0.62rem] font-black uppercase tracking-[0.24em] text-azure sm:text-xs" data-id="element-204" data-mp="1d0tbzb9lmz5x">
            Lo que dicen quienes ya empezaron
          </p>
          <h2 id="testimonios" className="mt-0.5 font-display text-lg uppercase leading-tight text-navy sm:text-2xl lg:text-3xl" data-id="element-205" data-mp="1416a6ocyjrcc">
            De cero a entender un proyecto solar
          </h2>
        </Reveal>

        <ul className="mt-3 grid gap-2 md:grid-cols-2 lg:grid-cols-3" data-id="element-206" data-mp="2ygilryjxkwfo">
          {testimonials.map((item, i) => <Reveal key={item.name} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-lg border border-navy/10 bg-mist p-3" data-id="element-207" data-mp="32g9alwpwd2hk" data-mpi={i}>
              <div className="flex items-center justify-between" data-id="element-208" data-mp="2q0exily20ek4">
                <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-209" data-mp="34qchsqsv4k41">
                  {Array.from({
                length: 5
              }).map((_, s) => <StarIcon key={s} size={13} className="fill-solar text-solar" data-id="element-210" data-mp="2zunbm4mc84yr" data-mpi={s} />)}
                </div>
                <QuoteIcon size={15} className="text-azure/40" aria-hidden="true" data-id="element-211" data-mp="2m0wc7p2bm1gr" />
              </div>
              <p className="mt-1.5 font-body text-[0.76rem] leading-snug text-navy sm:text-[0.8rem]" data-id="element-212" data-mp="2h0i3s5wt4pi7">
                “{item.text}”
              </p>
              <div className="mt-auto pt-2" data-id="element-213" data-mp="3shhuwy7f4yan">
                <p className="font-condensed text-base uppercase tracking-wide text-azure" data-id="element-214" data-mp="3sgox4mqftj4n">
                  {item.name}
                </p>
                <p className="text-[0.68rem] text-steel sm:text-[0.72rem]" data-id="element-215" data-mp="8dlmiwmnja9b">
                  {item.role} · {item.place}
                </p>
              </div>
            </Reveal>)}
        </ul>

        <Reveal delay={0.1} className="mt-3 flex justify-center" data-id="element-216" data-mp="ickx4kqz9fyy">
          <CtaButton size="lg" data-id="element-217" data-mp="i9oysvb7wp9z">
            ☀️ ¡SÍ! QUIERO APRENDER ENERGÍA SOLAR DESDE CERO
          </CtaButton>
        </Reveal>
      </div>
    </section>;
}